module.exports = __webpack_public_path__ + "img/49.bedebef3.gif";